'use client';

import { useState } from 'react';
import { Play } from '@doist/icons/brand';
import { Box, Image, OverlayButton } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { YouTubeVideo } from 'components/YouTubeVideo/YouTubeVideo';
import { useLocale } from 'next-intl';
import css from './video-section.module.css';
const videoID = 'fI-iTYAwL6c';

// On YouTube, language codes are slightly different.
function mapLanguageToYouTubeLanguage(locale: string) {
  switch (locale) {
    case 'zh-TW':
      return 'zh-Hant';
    case 'zh-CN':
      return 'zh-Hans';
    case 'nb':
      return 'no';
    default:
      return locale;
  }
}
export function VideoPlayer() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  const [hasUserInitiatedPlayback, setHasUserInitiatedPlayback] = useState(false);
  return <Box className={css.videoContainer} data-sentry-element="Box" data-sentry-component="VideoPlayer" data-sentry-source-file="video-player.tsx">
            {!hasUserInitiatedPlayback ? <>
                    <Image src={`/static/home/video-section/${locale}/poster-image.png`} width={1088} height={612} alt="" />
                    <OverlayButton startIcon={Play} aria-label={t('videoSection.play')} onClick={() => setHasUserInitiatedPlayback(true)}>
                        {t('videoSection.play')}
                    </OverlayButton>
                </> : <YouTubeVideo className={css.video} videoID={videoID} playerVars={{
      loop: 0,
      autoplay: 1,
      playsinline: 1,
      mute: 0,
      cc_lang_pref: locale !== 'en' ? mapLanguageToYouTubeLanguage(locale) : undefined,
      cc_load_policy: locale !== 'en' ? 1 : undefined
    }} />}
        </Box>;
}